<style lang="less">
    .k-dlg__inner {
        bottom: 1rem;
    }

    .msg-bar,
    .result-bar,
    .slider-bar {
        width: 95%;
        margin: 0 auto;
    }

    .dlg-btns {
        text-align: center;
        padding: 0 0 .3rem;
    }

    .line-x {
        background-image: linear-gradient(-90deg, #976626 0%, #F7C36B 48%, #976626 100%);
        font-size: 1px;
        height: 1px;
        margin: 0 auto;
        width: 90%;
    }
    .line-y {
        background-image: linear-gradient(90deg, #F7C36B 0%, #976626 48%, #F7C36B 100%);
        font-size: 1px;
        height: 1rem;
        width: 1px;
        position: absolute;
        right: 50%;
        top: .3rem;
    }
    .gameData {
        width: 90%;
        /* background: #f00; */
        position: relative;
        top: 0;
        right: 0;
        min-height: 1.5rem;
        margin: 0 auto;
    }
    .gameRes {
        padding:.3rem 0 0;
    }
    .gameRes dt {
        font-size: .24rem;
        color: #FFC15E;
    }
    .gameRes dd {
        font-size: .36rem;
        color: #FDED66;
        line-height: 2;
    }
    .gameRes .k-num-money {
        margin-left: .1rem;
    }

    .gameScore {
        font-size: .34rem;
        color: #FDED66;
        padding: .5rem 0 .3rem;
        line-height: 1.1;

    }

</style>

<template>
    <div class="k-dlg-wrap">
        <div class=" k-dlg__inner">
            <div class="k-dlg__head">
                <div class="k-dlg__title">
                    &nbsp;
                    <h4>本局结果</h4>
                </div>
                <div></div>
                <a class="k-dlg__close" @click="close"><span>关闭</span></a>
            </div>
            <div v-if="curAction" class="k-dlg__body">
                <div class="gameData">
                    <van-row>
                        <van-col span="12">
                            <dl class="gameRes gameRes--lt ta_center">
                                <dt>当天实际涨跌</dt>
                                <dd v-if="hasResult">
                                    <k-num-rate :value="+curAction.realPer" />
                                    <k-num-money :value="+curAction.realVal" />
                                </dd>
                                <dd v-else>?</dd>
                            </dl>

                        </van-col>
                        <van-col span="12">
                            <dl class="gameRes gameRes--rt ta_center">
                                <dt>你预测的涨跌</dt>
                                <dd>
                                    <k-num-rate :value="curAction.predictPer" />
                                    <k-num-money :value="curAction.predictVal" />
                                </dd>
                            </dl>
                        </van-col>
                    </van-row>
                    <div class="line-y"></div>
                </div>
                <div class="line-x"></div>
                <dl class="gameScore ta_center">
                    <dt>本局预测得分：
                        <k-num-score v-if="hasResult" :value="+curAction.gameScore" /><span v-else>
                            <k-txt-time :value="finalRes" skin="normal" /> 揭晓</span></dt>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'dlg-result',
        props: ['show', 'cupId', 'gameId', 'kid', 'today'],
        computed: {
            ...mapGetters(['isAfter', 'finalRes']),
            ...mapGetters('reality', ['curAction']),
            hasResult() {
                return this.isAfter(this.finalRes)
            }
        },
        methods: {
            close() {
                this.$emit("close")
            }
        },
        created() {}
    };

</script>
